import BaseComponent from '@/js/core/BaseComponent'
import Events from '@/js/core/EventDispatcher'
import gsap from 'gsap'

export default class Menu extends BaseComponent {
  static OPEN = 'menu--open'
  
  static root = '.menu'

  state = {
    ...this.state,
    open: false 
  }

  actions = {
    open: 'update',
  }

  selectors = {
    'image': '.poster .image',
    'nums[]': 'nav ul li > span',
    'links[]': 'nav ul li a span',
    'closeMenu': '[data-close-menu]',
  }

  listeners = {
    'click @closeMenu': () => {
      this.setState(() => ({
        open: false
      }))
    }
  }

  clear () {
    gsap.killTweensOf(this.$el)
    gsap.killTweensOf(this.$els.nums)
    gsap.killTweensOf(this.$els.image)
    gsap.killTweensOf(this.$els.links)
  }

  enter () {
    gsap.timeline({ defaults: { duration: 1.4, ease: 'expo.inOut' }
        , onStart: () => gsap.set(this.$el, { autoAlpha: 1 }) })
        .fromTo(this.$el, { yPercent: -100 }, { yPercent: 0}, '<')
        .fromTo(this.$els.image, { scale: 1.2, autoAlpha: 0 }, { scale: 1, autoAlpha: 1 }, '<+.2')
        .fromTo(this.$els.links, { yPercent: 120 }, { yPercent: 0, stagger: { amount: .4 } }, '<')
        .fromTo(this.$els.nums, { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1, stagger: { amount: .6 } }, '<+.1')
  }
  
  leave () {
    gsap.timeline({ onComplete: () => gsap.set(this.$el, { autoAlpha: 0 }) })
        .to(this.$el, { yPercent: -100, duration: 1, ease: 'expo.out' })
  }

  update () {
    const { open } = this.state
    this.$.body &&
    this.$.body[open 
      ? 'addClass' 
      : 'removeClass'
    ](Menu.OPEN)

    this.clear()
    if (open) {
      this.enter()
    } else {
      this.leave()
    }
  }

  mounted () {
    super.mounted()
    
    Events.on('menu:open', open => {
      this.setState(() => ({ open }))
    })
  }
}